import { getItemsIds } from '../../utils/common'
import {
  isSubActive,
  isSubAll,
  isSubRead,
  isSubUnread,
} from '../../utils/route'

import {
  SUB_MENU_DEFAULT_KEYS,
  SUB_MENU_ITEM_PARENT_KEY,
} from './SubMenu.constants'

function getSubMenuItemName(item) {
  return item[SUB_MENU_DEFAULT_KEYS.value]
}

function isSubMenuDefaultItem(item) {
  return Boolean(item.is_default)
}

function isSubMenuReadItem(item) {
  const name = getSubMenuItemName(item)

  return isSubRead(name) || isSubUnread(name)
}

function getSubMenuReadParentName(items) {
  const names = getSubMenuItemNames(items)

  return names.find(isSubActive) ?? names.find(isSubAll) ?? null
}

export function hasSubMenuItemName(items, name) {
  return getSubMenuItemNames(items).includes(name)
}

export function getSubMenuItemNames(items) {
  return getItemsIds(items, SUB_MENU_DEFAULT_KEYS.value)
}

export function getSubMenuDefaultItemName(items) {
  const defaultItem = items.find(isSubMenuDefaultItem) ?? items[0]

  return defaultItem ? getSubMenuItemName(defaultItem) : null
}

export function nestSubMenuReadItems(items) {
  const parentName = getSubMenuReadParentName(items)

  const readItems = items
    .filter(isSubMenuReadItem)
    .map(item => ({ ...item, [SUB_MENU_ITEM_PARENT_KEY]: parentName }))

  return parentName
    ? items
        .filter(item => !isSubMenuReadItem(item))
        .flatMap(item =>
          getSubMenuItemName(item) === parentName ? [item, ...readItems] : item
        )
    : items
}
